export default __webpack_public_path__ + "static/media/troup-county-historical-society.b2782f13.jpg";